import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { STUDENT_SCREENS } from "../../../../shared/accessControl";
const emptyForm = () => ({
  nome: "",
  ativo: true,
  telas_permitidas: STUDENT_SCREENS.map((item) => item.key),
});
export default function AdminGruposAcesso(props) {
  let gruposAcesso = props.gruposAcesso;
  let setGruposAcesso = props.setGruposAcesso;
  let students = props.students;
  let setStudents = props.setStudents;
  let showFlash = props.showFlash;
  let editingGrupoAcesso = props.editingGrupoAcesso;
  let setEditingGrupoAcesso = props.setEditingGrupoAcesso;
  const [form, setForm] = useState(emptyForm());
  useEffect(() => {
    if (editingGrupoAcesso) {
      const grupo = gruposAcesso.find(
        (grupoId) => grupoId.id === editingGrupoAcesso,
      );
      if (grupo) {
        setForm({
          nome: grupo.nome,
          ativo: !!grupo.ativo,
          telas_permitidas: Array.isArray(grupo.telas_permitidas)
            ? grupo.telas_permitidas
            : [],
        });
      }
    } else setForm(emptyForm());
  }, [editingGrupoAcesso, gruposAcesso]);
  const marcarTodas = (marcar) => {
    setForm((prev) => ({
      ...prev,
      telas_permitidas: marcar ? STUDENT_SCREENS.map((item) => item.key) : [],
    }));
  };
  return (
    <div className={"ga"}>
      <div
        className={"cr"}
        style={{
          marginBottom: 0,
        }}
      >
        {gruposAcesso.map((grupo) => {
          const tot = students.filter(
            (student) => student.ativo && student.grupo_acesso_id === grupo.id,
          ).length;
          const telas = Array.isArray(grupo.telas_permitidas)
            ? grupo.telas_permitidas
            : [];
          return (
            <div className={"cc"} key={grupo.id}>
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 900,
                  color: "#1F4754",
                  marginBottom: 4,
                }}
              >
                {grupo.nome}
              </div>
              <div className={"cmt"}>
                {telas.length}
                {" de "}
                {STUDENT_SCREENS.length}
                {" telas liberadas"}
              </div>
              <div
                className={"cmt"}
                style={{
                  marginTop: 2,
                }}
              >
                {tot}
                {" alunos"}
              </div>
              {!grupo.ativo && (
                <div
                  style={{
                    marginTop: 4,
                  }}
                >
                  <span className={"bst bof"}>{"Inativo"}</span>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  marginTop: 9,
                }}
              >
                <button
                  className={"btn bg bs"}
                  style={{
                    flex: 1,
                  }}
                  onClick={() => setEditingGrupoAcesso(grupo.id)}
                >
                  {"Editar"}
                </button>
                <button
                  className={"btn bd bs"}
                  style={{
                    flex: 1,
                  }}
                  onClick={() =>
                    (async (item) => {
                      try {
                        await api.delete("/grupos-acesso?id=".concat(item.id));
                        setStudents(
                          students.map((student) =>
                            student.grupo_acesso_id === item.id
                              ? {
                                  ...student,
                                  grupo_acesso_id: null,
                                }
                              : student,
                          ),
                        );
                        setGruposAcesso(
                          gruposAcesso.filter(
                            (grupoId) => grupoId.id !== item.id,
                          ),
                        );
                        if (editingGrupoAcesso === item.id) {
                          setEditingGrupoAcesso(null);
                        }
                        showFlash("Excluido.");
                      } catch (err) {
                        showFlash(
                          err.response?.data?.message ||
                            "Nao foi possivel excluir o grupo.",
                          "er",
                        );
                      }
                    })(grupo)
                  }
                >
                  {"X"}
                </button>
              </div>
            </div>
          );
        })}
        {0 === gruposAcesso.length && (
          <div
            style={{
              color: "#6B8590",
              fontSize: 12,
            }}
          >
            {"Nenhum grupo de acesso cadastrado."}
          </div>
        )}
      </div>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (!form.nome.trim()) {
            showFlash("Nome obrigatório.", "er");
            return;
          }
          const dados = {
            ...form,
            nome: form.nome.trim(),
          };
          try {
            const responseData2 = editingGrupoAcesso
              ? await api.put(
                  "/grupos-acesso?id=".concat(editingGrupoAcesso),
                  dados,
                )
              : await api.post("/grupos-acesso", dados);
            const saved = responseData2.data?.data ?? responseData2.data;
            if (editingGrupoAcesso) {
              setGruposAcesso(
                gruposAcesso.map((grupo) =>
                  grupo.id === editingGrupoAcesso ? saved : grupo,
                ),
              );
              showFlash("Atualizado.");
            } else {
              setGruposAcesso([...gruposAcesso, saved]);
              showFlash("Cadastrado.");
            }
            setEditingGrupoAcesso(null);
          } catch (err) {
            showFlash(
              err.response?.data?.message || "Nao foi possivel salvar o grupo.",
              "er",
            );
          }
        }}
        className={"fc"}
      >
        <div
          style={{
            fontWeight: 700,
            color: "#1F4754",
            fontSize: 13,
            marginBottom: 10,
          }}
        >
          {editingGrupoAcesso ? "Editar" : "Novo"}
          {" Grupo de Acesso"}
        </div>
        <div className={"fg"}>
          <label>{"Nome"}</label>
          <input
            className={"inp"}
            value={form.nome}
            onChange={(event) =>
              setForm({
                ...form,
                nome: event.target.value,
              })
            }
            required={true}
          />
        </div>
        <div className={"fg"}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              textTransform: "none",
              letterSpacing: "normal",
              fontSize: 13,
              color: "#1F4754",
            }}
          >
            <input
              type={"checkbox"}
              checked={form.ativo}
              onChange={(event) =>
                setForm({
                  ...form,
                  ativo: event.target.checked,
                })
              }
            />{" "}
            {"Ativo"}
          </label>
        </div>
        <div className={"fg"}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 6,
            }}
          >
            <label
              style={{
                margin: 0,
              }}
            >
              {"Telas permitidas"}
            </label>
            <div
              style={{
                display: "flex",
                gap: 6,
              }}
            >
              <button
                type={"button"}
                className={"btn bg bs"}
                onClick={() => marcarTodas(true)}
              >
                {"Marcar todas"}
              </button>
              <button
                type={"button"}
                className={"btn bg bs"}
                onClick={() => marcarTodas(false)}
              >
                {"Limpar"}
              </button>
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
              gap: 6,
            }}
          >
            {STUDENT_SCREENS.map((tela) => (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  textTransform: "none",
                  letterSpacing: "normal",
                  fontSize: 12,
                  color: "#1F4754",
                }}
                key={tela.key}
              >
                <input
                  type={"checkbox"}
                  checked={form.telas_permitidas.includes(tela.key)}
                  onChange={() => {
                    var key;
                    key = tela.key;
                    setForm((prev) => ({
                      ...prev,
                      telas_permitidas: prev.telas_permitidas.includes(key)
                        ? prev.telas_permitidas.filter(
                            (telas_permitida) => telas_permitida !== key,
                          )
                        : [...prev.telas_permitidas, key],
                    }));
                    return;
                  }}
                />{" "}
                {tela.label}
              </label>
            ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
            marginTop: 6,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {editingGrupoAcesso ? "Atualizar" : "Cadastrar"}
          </button>
          {editingGrupoAcesso && (
            <button
              type={"button"}
              className={"btn bg"}
              onClick={() => setEditingGrupoAcesso(null)}
            >
              {"Cancelar"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
export { AdminGruposAcesso };
